module.exports = __webpack_public_path__ + "static/media/yg.3515b066.jpg";